import { Button } from '@/components/ui/button';
import { useResponsive } from '@/hooks/use-responsive';
import { useGlobalStore } from '@/stores/store';
import { buildOrderFormUrlByOffers } from '@/utils/url';
import { useSearch } from '@tanstack/react-router';
import { useShallow } from 'zustand/react/shallow';

const ProceedCheckoutButton = () => {
  const { isDesktop } = useResponsive();
  const { 'agent-token': agentToken, conversation_id: conversationId } =
    useSearch({ strict: false });
  const { latestMobileOffer, latestBroadbandOffer, latestSelectedAddresses } =
    useGlobalStore(
      useShallow((store) => ({
        latestMobileOffer: store.shoppingCartStore.latestMobileOffer,
        latestBroadbandOffer: store.shoppingCartStore.latestBroadbandOffer,
        latestSelectedAddresses: store.addressStore.latestSelectedAddresses,
      }))
    );

  const handleCheckout = () => {
    //NOTE: We support just NBN provider, so we filter the providers to get the NBN one, and pass it to the orderform
    const nbnProvider = latestSelectedAddresses
      .at(0)
      ?.providers.find((provider) => provider.name === 'NBN');
    const redirectUrl = buildOrderFormUrlByOffers({
      mobilePlanId: latestMobileOffer?.id,
      broadbandPlanId: latestBroadbandOffer?.id,
      broadbandProvider: nbnProvider?.name.toLowerCase(),
      broadbandLocationId: nbnProvider?.locationId,
      agentToken: agentToken,
      conversationId: conversationId,
    });
    window.location.href = redirectUrl;
  };

  return (
    <div className="flex flex-1 w-full">
      <Button
        size={isDesktop ? 'medium' : 'small'}
        type="button"
        className="flex w-full"
        onClick={handleCheckout}
      >
        Proceed to checkout
      </Button>
    </div>
  );
};

export { ProceedCheckoutButton };
